module.exports = __webpack_public_path__ + "static/media/le-progres.64f05ed8.svg";